import routingService from 'common/src/modules/routing/routing.service';
import {RouteKey} from 'common/src/modules/routing/routing.enums';
import initializeCampaignsAgents from './initializeCampaignsAgents';
import initializeCampaignsUiContexts from './initializeCampaignsUiContexts';
import {CLStore} from 'common/src/redux/store';
import isCampaignPageNavigationCompleted from './isCampaignPageNavigationCompleted';

async function initializeCampaigns(store: CLStore) {
  routingService.registerDomainSpecificRouteFunctions(RouteKey.CampaignPage, {
    isNavigationComplete: isCampaignPageNavigationCompleted,
  });

  initializeCampaignsUiContexts(store);
  await initializeCampaignsAgents(store);
}

export default initializeCampaigns;
